<app-temp-modal-cadastro #modalConsultar modalContentId="modal-cadastro-itens-manifesto" (closed)="destroyComponent()"
  [textHeader]="'Cadastrar itens/Adicionar no estoque'" customClass="modal-xxl">
  <div class="app-modal-body">
    <div class="row">
      <div class="form-group col-sm-6">
        <label style="font-weight: bold; position: relative;">Almoxarifado
          <i class="ti-help-alt helpIcon"
            placement="bottom"
            ngbTooltip="Utilizado para configurar os itens com o Almoxarifado selecionado."
            style="position: absolute; bottom: 2px; right: -22px;"
          ></i>
        </label>
        <ng-select appendTo="#modal-cadastro-itens-manifesto" [loading]="loading['almoxarifados']"
          placeholder="Selecione" [items]="almoxarifados" bindLabel="nome" bindValue="id"
          [disableControl]="loading['request'] || loading['disable']" [(ngModel)]="almoxarifadoPadraoId">
          <ng-template ng-option-tmp let-item="item">
            <app-temp-option-item [name]="item.nome"
              (onClick)="abrirCadastroAlmoxarifado(item.id, null)">
            </app-temp-option-item>
          </ng-template>

          <ng-template ng-notfound-tmp let-items="items" let-searchTerm="searchTerm">
            <app-temp-not-found-item [searchTerm]="searchTerm"
              (onClick)="abrirCadastroAlmoxarifado(null, searchTerm)">
            </app-temp-not-found-item>
          </ng-template>
        </ng-select>
      </div>
    </div>

    <div class="text-center" *ngIf="loadingData"><i class="fa fa-circle-notch fa-spin fa-2x"></i></div>

    <ng-container>
      <table class="table table-bordered table-striped-2" *ngIf="itensNaoMovimentados && itensNaoMovimentados.length > 0">
        <thead>
          <tr>
            <th style="width: 0">
              <app-dim-checkbox (change)="selecionarTodos($event)"></app-dim-checkbox>
            </th>
            <th style="width: 0">Cód. Entrada<br>Código</th>
            <th>Nome Entrada<br>Nome</th>
            <th style="width: 12.9%">Validade</th> <!-- 13 nunca-->
            <th style="width: 0">Unid. Entrada<br>Unid. Estoque</th>
            <th style="width: 0">Qtde. Entrada<br>Qtde. Estoque</th>
            <th style="width: 0">Custo Entrada<br>Preço Venda</th>
          </tr>
        </thead>
        <tbody>
          <ng-container *ngFor="let row of itensNaoMovimentados">
            <tr class="tr-cima">
              <td style="width: 0">
                <app-dim-checkbox [(ngModel)]="row.selecionado"></app-dim-checkbox>
              </td>
              <td>
                {{row.itemFornecedor.referenciaItem}}
              </td>
              <td class="text-overflow">
                <i class="ti ti-info-alt"
                  [ngClass]="'itens-manifesto__ti-info-alt--color-' + statusItemCor(row)"
                  placement="right"
                  [ngbTooltip]="statusItemNgbTooltip(row)"
                ></i> {{row.itemFornecedor.nome}}
              </td>
              <td class="centeredText">
                &nbsp;
              </td>
              <td class="centeredText">
                {{row.itemFornecedor.unidade}}<br>
              </td>
              <td class="centeredText">
                {{row.quantidade}}
              </td>
              <td class="centeredText">
                {{row.custoEntrada | currency:'BRL'}}
              </td>
            </tr>
            <tr class="tr-baixo">
              <td></td>
              <td>
                <span *ngIf="row.itemFornecedor.item">{{row.itemFornecedor.item?.referenciaItem}}</span>
                <span *ngIf="!row.itemFornecedor.item">{{row.codigo || '-'}}</span>
              </td>
              <td class="text-overflow" style="max-width: 1px">
                <span *ngIf="row.itemFornecedor.item">{{row.itemFornecedor.item?.nome}}</span>
                <app-combobox-produto #combo *ngIf="!row.itemFornecedor.item" [label]="null"
                  class="combobox-produto" [(ngModel)]="row.novoItemID" appendTo="#modal-cadastro-itens-manifesto"
                  [exibeAlteraItem]="true" (detalhaItem)="createViewDetalhaItem(row, $event, combo)"
                  (change)="produtoChanged(row, $event, combo)" [mostrarFiltro]="false" pesquisaSelecionada="referenciaItem,nome"
                  [autoload]="false" placeholder="Cadastro automático">
                </app-combobox-produto>
              </td>
              <td class="centeredText">
                <app-data calenderPosition="left" [(ngModel)]="row.validade"></app-data>
              </td>
              <td class="centeredText">
                <ng-select appendTo="#modal-cadastro-itens-manifesto"
                  [loading]="!unidadesMedida || !unidadesMedida.length" placeholder="Selecione"
                  [items]="unidadesMedida" bindLabel="unidade" bindValue="id" [(ngModel)]="row.unidadeMedidaID">
                </ng-select>
              </td>
              <td class="centeredText">
                <input class="editable-input" inputmode="numeric" [(ngModel)]="row.quantidadeEstoque" />
              </td>
              <td class="centeredText">
                <input class="editable-input" inputmode="numeric" [(ngModel)]="row.precoVenda" currencyMask />
              </td>
            </tr>
          </ng-container>
        </tbody>
      </table>
    </ng-container>

    <div *ngIf="!loadingData && itensNaoMovimentados && itensNaoMovimentados.length === 0" class="text-center mt-1 mb-4">
      Todos os itens já existem como produtos de venda e o estoque foi movimentado
    </div>

    <div *ngIf="statusSelecionados() !== 'ok' && !movimentarEstoque">
      <span style="font-size: 13px; padding-left: 5px;" [innerHTML]="statusSelecionadosError()"></span>
    </div>

    <div class="d-flex flex-flow mt-1" [ngStyle]="{'margin-top': (statusSelecionados() !== 'ok' && !movimentarEstoque) ? '18px' : '0'}">
      <button type="button" class="btn btn-primary d-flex flex-flow itens-manifesto__footer-btn--align-icon"
        [disabled]="loading || possuiItensSelecionados" (click)="importar()"
        ><i class="ti ti-save" aria-hidden="true"></i> Salvar
      </button>
      <button type="button" class="btn btn-danger d-flex flex-flow itens-manifesto__footer-btn--align-icon"
        (click)="modalConsultar.hide()"
        ><i class="ti ti-close" aria-hidden="true"></i> Cancelar
      </button>

      <app-dim-checkbox [(ngModel)]="movimentarEstoque" label="Movimentar estoque" tooltip="Os itens importados movimentarão o estoque"
        class="mt-2 ml-3"></app-dim-checkbox>

      <app-dim-checkbox [(ngModel)]="naoVincularItens" label="Não vincular itens de entrada com itens internos" class="mt-2 ml-3"></app-dim-checkbox>
    </div>
</div>
</app-temp-modal-cadastro>

<app-abrir-modal #abrirModal></app-abrir-modal>